const listeners = new Set<() => void>();
let ticking = false;

function onScroll() {
    if (!ticking) {
        ticking = true;
        const schedule = (callback: () => void) => {
            if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
                window.requestAnimationFrame(callback);
            } else {
                setTimeout(callback, 16);
            }
        };
        schedule(() => {
            listeners.forEach((listener) => listener());
            ticking = false;
        });
    }
}

function attachListener() {
    if (typeof window !== "undefined") {
        window.addEventListener("scroll", onScroll, { passive: true });
    }
}

function detachListener() {
    if (typeof window !== "undefined") {
        window.removeEventListener("scroll", onScroll, { passive: true } as EventListenerOptions);
    }
}

export function subscribe(listener: () => void) {
    listeners.add(listener);

    // Attach scroll listener if this is the first subscriber
    if (listeners.size === 1) {
        attachListener();
    }

    return () => {
        listeners.delete(listener);

        // Remove scroll listener if there are no subscribers left
        if (listeners.size === 0) {
            detachListener();
        }
    };
}
